import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/prepa`;
const token = localStorage.getItem("token");

/// GET : tous les exercices
export const getAllExercises = async () => {
  try {
    const response = await axios.get(`${apiUrl}/all`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur getAllExercises:", error);
    return [];
  }
};

/// GET : exercices par adhérent
export const getExercisesByAdherent = async (adherentId) => {
  try {
    const response = await axios.get(`${apiUrl}/adherent/${adherentId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur getExercisesByAdherent:", error);
    return null;
  }
};

/// GET : détail d'un exercice pour un adhérent
export const getAdherentExerciseDetails = async (adherentId, exerciseId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/adherent/${adherentId}/exercise/${exerciseId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur getAdherentExerciseDetails:", error);
    return null;
  }
};

// Tous les exercices réalisés par tous les adhérents
export const getAllAdherentExerciseResults = async () => {
  try {
    const response = await axios.get(`${apiUrl}/all-adherents`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur getAllAdherentExerciseResults:", error);
    return [];
  }
};

/// POST : créer un nouvel exercice
export const createExercise = async (exerciseData) => {
  try {
    const response = await axios.post(`${apiUrl}/create`, exerciseData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur createExercise:", error);
    return null;
  }
};

/// POST : enregistrer la réalisation d'un exercice
export const addAdherentExerciseResult = async (resultData) => {
  try {
    const response = await axios.post(`${apiUrl}/adherent/add-result`, resultData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur addAdherentExerciseResult:", error);
    return null;
  }
};

/// PUT : modifier un exercice
export const editExercise = async (id, updatedData) => {
  try {
    const response = await axios.put(`${apiUrl}/edit/${id}`, updatedData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur editExercise:", error);
    return null;
  }
};

/// PUT : modifier une réalisation d’exercice
export const updateAdherentExerciseResult = async (updateData) => {
  try {
    const response = await axios.put(`${apiUrl}/adherent/update-result`, updateData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur updateAdherentExerciseResult:", error);
    return null;
  }
};

/// DELETE : supprimer un exercice
export const deleteExercise = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/delete/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur deleteExercise:", error);
    return null;
  }
};

/// DELETE : supprimer un résultat d’un adhérent
export const deleteAdherentExerciseResult = async (adherentId, exerciseId) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/adherent/delete-result/${adherentId}/${exerciseId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur deleteAdherentExerciseResult:", error);
    return null;
  }
};
